import React from 'react';
import { withStyles, Box, Button } from '@material-ui/core';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Modal, Typography } from '@orijinworks/frontend-commons';
import ExportAllWithEmail from '../../../../shared/components/ExportAllWithEmail/ExportAllWithEmail';
import { ExportPlanSectionItem } from './export-plan-section-item';
import { useExportPlanModalHook } from './useExportPlanModalHook';
import styles, { ExportPlanModalStyles } from './export-plan-modal.styles';

const EXPORT_INFO_NOTE =
  'Selection includes sections with HonestJobs widgets. Every job and resource the learner saved will export in full.';

function ExportPlanModal({ classes, open = false, onClose, onExport, sections = [] }) {
  const {
    modalRef,
    isSectionStepOpen,
    isEmailStepOpen,
    isAllSelected,
    hasSelectedSections,
    handleToggleSection,
    handleToggleSelectAll,
    handleExportPlanClick,
    handleEmailExport,
    handleClose,
    handleEmailClose,
    selectedIds,
  } = useExportPlanModalHook({ open, onClose, onExport, sections });

  return (
    <>
      <Modal
        ref={modalRef}
        open={isSectionStepOpen}
        onClose={handleClose}
        onContinue={handleExportPlanClick}
        heading="Export Plan"
        labelledBy="Export Plan"
        describedBy="Select case plan sections to export"
        cancelBtnText="Cancel"
        actionBtnText="Export Plan"
        actionBtnId="export-plan-continue-btn"
        showCrossIcon
        modalType={{ type: 'normal', status: 'info', size: 'medium' }}
        continueButtonProps={{ disabled: !hasSelectedSections }}
        styles={{ mainWrapperStyles: { width: 580, minWidth: 580, maxWidth: 780 } }}
        mainModalStyles={ExportPlanModalStyles}
        showFooter
      >
        <Box className={classes.content}>
          <Box className={classes.sectionsHeader}>
            <Typography className={classes.sectionsLabel} variant="overlineSmall">
              Sections
            </Typography>
            <Button
              variant="text"
              color="primary"
              className={classes.selectAllButton}
              onClick={handleToggleSelectAll}
              aria-label={isAllSelected ? 'Deselect all sections' : 'Select all sections'}
            >
              {isAllSelected ? 'Deselect all' : 'Select all'}
            </Button>
          </Box>

          <Box className={classes.sectionList}>
            {sections.map((section) => (
              <ExportPlanSectionItem
                key={section.id}
                classes={classes}
                section={section}
                isSelected={selectedIds.includes(section.id)}
                onToggle={handleToggleSection}
              />
            ))}
          </Box>

          <Box className={classes.infoNote}>
            <InfoOutlinedIcon className={classes.infoIcon} aria-hidden="true" />
            <p className={classes.infoText}>{EXPORT_INFO_NOTE}</p>
          </Box>
        </Box>
      </Modal>

      <ExportAllWithEmail
        open={isEmailStepOpen}
        onClose={handleEmailClose}
        onExport={handleEmailExport}
      />
    </>
  );
}

ExportPlanModal.defaultProps = {
  open: false,
  onClose: undefined,
  onExport: undefined,
  sections: [],
};

export default withStyles(styles)(ExportPlanModal);
